import React, { useState } from "react";
import { Col, Form, Typography } from "antd";
import { CustomButton } from "../adaptors/CustomButton";
import CustomInput from "../adaptors/CustomInput";
import { CustomLink } from "../adaptors/CustomLink";
import { emailValidator } from "../../utils/helpers/validations";
import { variants } from "../../utils/variants";
import "../sections/auth.scss";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { userActions } from "../../utils/redux/actions";
import { LOGIN } from "../../../graphql/mutations/auth";
import {
  ADD_USER_DETAILS,
  REDUX_PERSIST,
  VERIFY_OTP,
} from "../../utils/localization";
import { gqlErrors } from "../../../graphql/errors";
import FormErrorMessage from "../FormErrorMessage";
import { setCookie } from "../../helpers/auth";
import { useMutation } from "@apollo/client";
import { GET_LOCATION_LIST } from "../../../graphql/queries/location";
import { getFormattedLocationList } from "../../helpers/auth";
import { initializeApollo } from "../../../apollo-client";
import { logger } from "../../helpers/logger";

const { Title, Paragraph } = Typography;

const LoginContent = (props) => {
  const { form, onAuthStateChange } = props;
  const { setFields } = form;
  const dispatch = useDispatch();
  const { userUpdateAction } = bindActionCreators(userActions, dispatch);
  const [login] = useMutation(LOGIN);
  const [loggingIn, setLoggingIn] = useState(false);

  const handleLogin = async (email) => {
    try {
      const { data } = await login({ variables: { email } });
      if (data?.login?.accessToken) {
        const apolloClient = initializeApollo({
          initialState: null,
          ctx: null,
        });
        try {
          const { data: locationListData } = await apolloClient.query({
            query: GET_LOCATION_LIST,
            fetchPolicy: "network-only",
          });
          if (locationListData?.LocationList) {
            userUpdateAction({
              encryptedAuthToken: data.login.accessToken,
              locationList: getFormattedLocationList(
                locationListData?.LocationList[0]?.children
              ),
            });
            setCookie(data.login.accessToken);
            setLoggingIn(false);
            onAuthStateChange(ADD_USER_DETAILS);
          }
        } catch (error) {
          setLoggingIn(false);
          const gqlError = error.graphQLErrors[0];
          if (gqlError) {
            logger.print(gqlError.message);
          }
        }
      }
    } catch (error) {
      setLoggingIn(false);
      const gqlError = error?.graphQLErrors[0];
      if (gqlError.message === gqlErrors.messages.accessDenied) {
        setFields([
          {
            name: "email",
            errors: [
              <FormErrorMessage
                key="email-error-message"
                type="unauthorized"
              />,
            ],
          },
        ]);
      }
      if (gqlError?.message === gqlErrors.messages.loginOTP) {
        onAuthStateChange(VERIFY_OTP);
      }
      if (gqlError?.message === gqlErrors.messages.email) {
        setFields([
          {
            name: "email",
            errors: [
              <FormErrorMessage key="email-error-message" type="email" />,
            ],
          },
        ]);
      }
    }
  };

  const onFinish = (values) => {
    setLoggingIn(true);
    let { email } = values;
    if (localStorage.getItem(REDUX_PERSIST) !== null) {
      localStorage.removeItem(REDUX_PERSIST);
    }
    handleLogin(email);
  };

  return (
    <Col className="authCard">
      <Title className="authCardTitle">Welcome to Unschool</Title>
      <Paragraph className="authCardSubText">
        Get started by accessing your learning dashboard
      </Paragraph>
      <Form
        form={form}
        name="basic"
        initialValues={{
          email: "",
        }}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              validator: emailValidator,
            },
          ]}
        >
          <CustomInput
            formItem
            label="Email"
            variant={variants.textInput}
            placeholder="Email"
            type="email"
          />
        </Form.Item>
        <Form.Item className="submitFormItem">
          <CustomButton
            htmlType="submit"
            variant={variants.primaryButton}
            title="Continue"
            formNoValidate
            customClass="submitBtn"
            loading={loggingIn}
            disabled={loggingIn}
          />
        </Form.Item>
      </Form>
      <Paragraph className="authCardFooterText">
        By continuing you agree to Unschool&#39;s
        <CustomLink nativeLink href="#" size="tiny" customClass="termsLink">
          Terms and Conditions
        </CustomLink>
        .
      </Paragraph>
      <Paragraph className="termsLinkMobile">
        <CustomLink nativeLink href="#" size="tiny" customClass="termsLink">
          Terms and Conditions
        </CustomLink>
        .
      </Paragraph>
    </Col>
  );
};

export default LoginContent;
